/**
 * Testi dell'interfaccia. La terminologia che dipende dalla specie
 * (Cucciolo/Puledro, Cucciolata/Figliata) NON sta qui: arriva dal server
 * nel contesto di specie, perché cambia per specie e per associazione,
 * non per lingua.
 */
export const it = {
  'app.name': 'PedigreeSmart',

  'action.save': 'Salva',
  'action.cancel': 'Annulla',
  'action.delete': 'Elimina',
  'action.search': 'Cerca',
  'action.export': 'Esporta',
  'action.back': 'Indietro',

  'nav.dashboard': 'Cruscotto',
  'nav.people': 'Anagrafiche',
  'nav.members': 'Soci',
  'nav.animals': '{animals}',
  'nav.declarations': 'Denunce',
  'nav.litters': '{litters}',
  'nav.listings': 'Vetrina',
  'nav.settings': 'Impostazioni',
  'nav.billing': 'Abbonamento',

  'animal.registry_number': 'Numero di registro',
  'animal.name': 'Nome',
  'animal.sex': 'Sesso',
  'animal.birth_date': 'Data di nascita',
  'animal.breed': 'Razza',
  'animal.color': 'Colore',
  'animal.owner': 'Proprietario',
  'animal.keeper': 'Detentore',
  'animal.inbreeding': 'Consanguineità',
  'animal.pedigree': 'Genealogia',
  'animal.completeness': 'Completezza dell’albero',

  'declaration.type.registration': 'Prima iscrizione',
  'declaration.type.mating': 'Denuncia di monta',
  'declaration.type.birth': 'Denuncia di nascita',
  'declaration.type.transfer': 'Passaggio di proprietà',
  'declaration.status.draft': 'Bozza',
  'declaration.status.submitted': 'Presentata',
  'declaration.status.review': 'In istruttoria',
  'declaration.status.approved': 'Approvata',
  'declaration.status.rejected': 'Respinta',
  'declaration.status.registered': 'Registrata',

  'billing.currentPlan': 'Piano attuale',
  'billing.billableAnimals': 'Animali fatturabili',
  'billing.estimate': 'Stima prossima fattura',
  'billing.invoices': 'Fatture',

  'error.generic': 'Si è verificato un errore. Riprova.',
  'error.unauthorized': 'Sessione scaduta. Accedi di nuovo.',
  'error.forbidden': 'Non hai i permessi per questa operazione.',
  'error.notFound': 'Elemento non trovato.',

  'tenant.readOnly': 'Abbonamento sospeso: puoi consultare ed esportare i dati, ma non modificarli.',
} satisfies Record<string, string>
